<template>
  <div class="ai-content">
    <Headermenu :menu-color="'AI'"
                :is-ai="true"></Headermenu>
    <div class="search-content">
      <a-input v-model:value="searchValue"
               :placeholder="showTip" />
      <a-button v-if="isLoading"
                :disabled="true"
                class="btn-width loadingBtn">{{ $t('home.InspirationAI.create') }}</a-button>
      <a-button v-else
                class="btn-width"
                @click="create">{{ $t('home.InspirationAI.create') }}</a-button>
      <a-button @click="randomInspiration">{{ $t('home.InspirationAI.randomInspiration') }}</a-button>
      <div class="separate-line"></div>
      <a-tooltip placement="bottom"
                 :color="'#fff'">
        <template #title>
          <span style="color: #111;">{{ $t('home.InspirationAI.inspiration') }}</span>
        </template>
        <div class="ai-icon ai-list"
             @click="goToAiList"></div>
      </a-tooltip>
      <!-- <a-tooltip placement="bottom"
                 :color="'#fff'">
        <template #title>
          <span style="color: #111;">购买派币</span>
        </template>
        <div class="ai-icon ai-coin"></div>
      </a-tooltip>
      <div class="coin-box">10</div> -->
    </div>

    <div v-show="!isDetail"
         class="ai-container">
      <!-- 灵感集页 -->
      <div v-if="showKey == 'inspiration'"
           class="inspiration-image">
        <div v-for="(item, index) in preset_image"
             :key="index"
             class="image-preset"
             @mouseenter="imageMouseenter(index)"
             @mouseleave="imageMouseleave"
             @click="clickInspiration(item)">
          <div v-if="isHover && imageIndex == index"
               class="image-text">{{ item.desc }}</div>
          <a-image :preview="false"
                   :src="item.image" />
        </div>
      </div>
      <!-- AI图片页 -->
      <div v-else
           class="inspiration-ai">
        <div style="display: flex;cursor: pointer;">
          <div class="inspiration-icon"></div>
          <div class="inspiration-title"
               @click="goToInspiration">{{ $t('home.InspirationAI.inspirationAI') }}</div>
        </div>
        <!-- AI loading 页 -->
        <div v-if="showKey == 'AILoading'"
             class="inspiration-content">
          <div style="position: relative;overflow: hidden;">
            <img :src="loading_image"
                 class="loading-image" />
            <img :src="scan_image"
                 class="scan-image" />
          </div>
          <div class="loading-title">
            <div class="loading-subtitle">{{ $t('home.InspirationAI.inspirationSubtitle') }}</div>
            <div class="loading-progress">{{ progress }}</div>
            <div>%</div>
          </div>
        </div>
        <!-- AI 生成完成 页 -->
        <div v-if="showKey == 'AIImage'"
             class="inspiration-ai-create">
          <div v-for="item in image_ai_create"
               :key="item.id">
            <a-image :preview="false"
                     :src="`${item.imageUrl}&width=350&height=350`"
                     @click="goToImageDetail(item)" />
          </div>
        </div>
        <!-- 创作集 -->
        <div v-if="showKey == 'AIList'"
             class="inspiration-ai-list">
          <div v-for="list in AiHistory"
               :key="list.id"
               class="history-item"
               @click="goToAIImage(list.subData)">
            <div v-if="isLoading && list.subData.length < 4"
                 class="loading-data">
              <LoadingOutlined class="loading-icon" />
            </div>
            <a-image v-else
                     :preview="false"
                     :src="`${list.imageUrl}&width=500&height=500`" />
          </div>
        </div>
      </div>
    </div>
    <!-- 图片详细信息 页 -->
    <div v-show="isDetail"
         class="image-content">
      <div class="image-title">
        <div class="select-icon"></div>
        <div @click="reselect">{{ $t('home.InspirationAI.reselect') }}</div>
      </div>
      <div style="display: flex;align-items: center;">
        <div class="left-arrow"
             @click="goToLeft(image_detail.id)"></div>
        <a-image :preview="false"
                 :src="`${image_detail?.imageUrl}&width=800&height=800`" />
        <div class="right-arrow"
             @click="goToRight(image_detail.id)"></div>
        <div class="detail-content">
          <div class="detail-prompt">{{ image_detail?.prompt }}</div>
          <!-- <div>1024 x 1024 | PNG</div> -->
          <a-button @click="goToDesign">
            <SelectOutlined />{{ $t('home.InspirationAI.goToDesign') }}
          </a-button>
        </div>
      </div>
    </div>
    <Footer :is-ai="true"></Footer>
  </div>
</template>

<script setup lang="ts">
import Headermenu from "./components/HeaderMenu.vue"
import Footer from "./components/Footer.vue"
import { creatAiImage, queryGroup, querySub, queryHistory } from '../api/index'
import image_bonfire from '../assets/ai_imgs/image_bonfire.jpg'
import image_lighthouse from '../assets/ai_imgs/image_lighthouse.jpg'
import image_train from '../assets/ai_imgs/image_train.jpg'
import image_street from '../assets/ai_imgs/image_street.jpg'
import image_music_festival from '../assets/ai_imgs/image_music_festival.jpg'
import image_tangerine from '../assets/ai_imgs/image_tangerine.jpg'
import image_wooden from '../assets/ai_imgs/image_wooden.jpg'
import image_grass from '../assets/ai_imgs/image_grass.jpg'
import image_table from '../assets/ai_imgs/image_table.jpg'
import image_landscape from '../assets/ai_imgs/image_landscape.jpg'
import image_cowboy from '../assets/ai_imgs/image_cowboy.jpg'
import image_girl from '../assets/ai_imgs/image_girl.jpg'
import image_cat from '../assets/ai_imgs/image_cat.jpg'
import image_sea_mew from '../assets/ai_imgs/image_sea_mew.jpg'
import image_food_stand from '../assets/ai_imgs/image_food_stand.jpg'
import loading_image from '../assets/ai_imgs/loading.png'
import scan_image from '../assets/ai_imgs/scan.png'
import { onBeforeUnmount, onMounted, computed, ref } from 'vue'
import { CORE_USER } from "@/core/CoreSymbol"
import type { LoginPageOption, LoginPageService, Plugin } from "@/plugins"
import type { UserService } from "@/core"
import { PLUGIN_AUTH } from "@/plugins/builtin/BuiltinPluginSymbol"
import Cookie from "js-cookie"
import { container } from "tsyringe"
import { message } from "ant-design-vue"
import { useRouter } from "vue-router"
import { useI18n } from 'vue-i18n'

import BigNumber from "bignumber.js"
BigNumber.config({ ROUNDING_MODE: 1 })
const { t } = useI18n()

const router = useRouter()
const isLogin = computed(() => {
  const userService = container.resolve<UserService>(CORE_USER)
  const loginOptions =
    container.resolve<Plugin<LoginPageOption, LoginPageService>>(PLUGIN_AUTH)
  const isUserValid = userService.isUserValid()
  const cookie = Cookie.get(loginOptions.options.cookieKey || "iota")
  const isLogged = isUserValid && cookie && cookie.length > 0
  return isLogged
})

const isLoading = ref<boolean>(false)
const isDetail = ref<boolean>(false)
const showKey = ref<string>("")
const isHover = ref<boolean>(false)
const imageIndex = ref<number>()
const progress = ref<number>(0)
onMounted(async () => {
  showKey.value = 'inspiration'
  await fetchHistory()
})
const AiHistory = ref<any>()
const showTip = ref<string>(t('home.InspirationAI.searchContent'))
const fetchHistory = async () => {
  await queryHistory().then((res: any) => {
    AiHistory.value = res
    let isComplete = true
    const uncompleteData = res[0]?.subData?.filter((r: any) => { return !r.progress || r.progress !== '100%' })
    uncompleteData.length > 0 ? isComplete = false : ''
    if (res.length > 0 && (res[0].subData.length != 4 || !isComplete)) {
      isLoading.value = true
      showTip.value = t('home.InspirationAI.showTip')
      queryImageProcess(res[0].id)
    }
  })
}
onBeforeUnmount(() => {
  clearInterval(timer)
})
const imageMouseenter = (index: number) => {
  isHover.value = true
  imageIndex.value = index
}
const imageMouseleave = () => {
  isHover.value = false
  imageIndex.value = 0
}
const clickInspiration = (item: any) => {
  searchValue.value = item.desc
}
const goToAiList = () => {
  if (!isLogin.value) {
    message.warn(t('home.InspirationAI.warnMsg'))
    router.push('/signin?fallback=AI')
    return
  }
  showKey.value = 'AIList'
  isDetail.value = false
}
const goToInspiration = () => {
  showKey.value = 'inspiration'
}
const searchValue = ref<string>('')
const preset_image = computed(() => [
  {
    image: image_bonfire,
    desc: t('home.InspirationAI.bonfire')
  },
  {
    image: image_lighthouse,
    desc: t('home.InspirationAI.lighthouse')
  },
  {
    image: image_train,
    desc: t('home.InspirationAI.train')
  },
  {
    image: image_street,
    desc: t('home.InspirationAI.street')
  },
  {
    image: image_music_festival,
    desc: t('home.InspirationAI.music')
  },
  {
    image: image_tangerine,
    desc: t('home.InspirationAI.tangerine')
  },
  {
    image: image_wooden,
    desc: t('home.InspirationAI.wooden')
  },
  {
    image: image_grass,
    desc: t('home.InspirationAI.grass')
  },
  {
    image: image_table,
    desc: t('home.InspirationAI.table')
  },
  {
    image: image_landscape,
    desc: t('home.InspirationAI.landscape')
  },
  {
    image: image_cowboy,
    desc: t('home.InspirationAI.cowboy')
  },
  {
    image: image_girl,
    desc: t('home.InspirationAI.girl')
  },
  {
    image: image_cat,
    desc: t('home.InspirationAI.cat')
  },
  {
    image: image_sea_mew,
    desc: t('home.InspirationAI.mew')
  },
  {
    image: image_food_stand,
    desc: t('home.InspirationAI.stand')
  }
])
const create = async () => {
  if (!isLogin.value) {
    router.push('/signin?fallback=AI')
    return
  }
  if (searchValue.value) {
    isLoading.value = true
    await creatAiImage({ prompt: searchValue.value }).then(async (res: any) => {
      isDetail.value = false
      showKey.value = 'AILoading'
      while (true) {
        const queryResult: any = await queryGroup(res.groupId)
        progress.value = new BigNumber(queryResult.progress).idiv(2).toNumber()
        if (queryResult?.progress === '100') {
          await queryImageProcess(queryResult.data.id)
          break
        }
        await sleep(2000)
      }
    })
  } else {
    message.error(t('home.InspirationAI.error'))
  }
}
const randomInspiration = () => {
  const arr = [t('home.InspirationAI.dream'), t('home.InspirationAI.dog'), t('home.InspirationAI.cats'), t('home.InspirationAI.mountain'), t('home.InspirationAI.water'), t('home.InspirationAI.wind'), t('home.InspirationAI.rain'), t('home.InspirationAI.flower'), t('home.InspirationAI.tree'), t('home.InspirationAI.bird'), t('home.InspirationAI.sun'), t('home.InspirationAI.moon'), t('home.InspirationAI.star'), t('home.InspirationAI.stone'), t('home.InspirationAI.sea'), t('home.InspirationAI.lake'), t('home.InspirationAI.snow'), t('home.InspirationAI.glass'), t('home.InspirationAI.spring'), t('home.InspirationAI.bridge'), t('home.InspirationAI.cloud'), t('home.InspirationAI.eat'), t('home.InspirationAI.fruit'), t('home.InspirationAI.dreamscape'), t('home.InspirationAI.tea'), t('home.InspirationAI.dream'), t('home.InspirationAI.starrySky'), t('home.InspirationAI.fantasy'), t('home.InspirationAI.happiness'), t('home.InspirationAI.sunshine'), t('home.InspirationAI.moonLight'), t('home.InspirationAI.greenTrees'), t('home.InspirationAI.blueSky'), t('home.InspirationAI.whiteClouds'), t('home.InspirationAI.seawaves'), t('home.InspirationAI.flowingWater'), t('home.InspirationAI.mountainsRivers'), t('home.InspirationAI.stones'), t('home.InspirationAI.windRain'), t('home.InspirationAI.ocean'), t('home.InspirationAI.asbyss'), t('home.InspirationAI.iceSnow'), t('home.InspirationAI.autumnLeaves'), t('home.InspirationAI.flowers'), t('home.InspirationAI.waterfall'), t('home.InspirationAI.stars'), t('home.InspirationAI.constellations'), t('home.InspirationAI.rainbow'), t('home.InspirationAI.snowflake'), t('home.InspirationAI.senseMystery'), t('home.InspirationAI.warmHeart'), t('home.InspirationAI.momentsHappiness'), t('home.InspirationAI.smilingFace'), t('home.InspirationAI.dreamlikeRealm'),
  t('home.InspirationAI.underGreenTrees'), t('home.InspirationAI.brillianceStarlight'), t('home.InspirationAI.luckyStar'), t('home.InspirationAI.inForest'), t('home.InspirationAI.quietNight'),
  t('home.InspirationAI.soundWater'), t('home.InspirationAI.deepSea'), t('home.InspirationAI.brightMorning'), t('home.InspirationAI.inFlight'), t('home.InspirationAI.laughingFace'), t('home.InspirationAI.feelingSadness'), t('home.InspirationAI.momentsDeepAffection'), t('home.InspirationAI.timesContemplation'), t('home.InspirationAI.senseWorry'),
  t('home.InspirationAI.poeticBeauty'), t('home.InspirationAI.senseJoy'), t('home.InspirationAI.thanksgiving'), t('home.InspirationAI.nationalDay'), t('home.InspirationAI.senseWilderness'),
  t('home.InspirationAI.whenFlowersBloom'), t('home.InspirationAI.timesLonging'), t('home.InspirationAI.ancientPrayer'), t('home.InspirationAI.twinklingStars'), t('home.InspirationAI.warmEver'), t('home.InspirationAI.overflowingHappiness'), t('home.InspirationAI.blossomingFlowers'),
  t('home.InspirationAI.lightHope'), t('home.InspirationAI.beautifulPainting'), t('home.InspirationAI.timeFlies'), t('home.InspirationAI.tranquilityTime'), t('home.InspirationAI.endlessDesert'),
  t('home.InspirationAI.windowSoul'), t('home.InspirationAI.magicalMoments'), t('home.InspirationAI.flowersSea'), t('home.InspirationAI.brilliantStarlight'), t('home.InspirationAI.magicMiracle'),
  t('home.InspirationAI.risingRainbow'), t('home.InspirationAI.mythologicalHeritage'), t('home.InspirationAI.warmthFamily'), t('home.InspirationAI.questTreasure'),]
  const index = Math.round(Math.random() * 99)
  searchValue.value = arr[index]
}
let timer = null as any
const sleep = (ms: number) => {
  return new Promise(resolve => {
    timer = setTimeout(resolve, ms)
  })
}
const image_ai_create = ref<any[]>()
const queryImageProcess = async (id: any) => {
  while (true) {
    const querySubRes: any = await querySub(id)
    progress.value = new BigNumber(100).plus(querySubRes.progress).idiv(2).toNumber()
    if (querySubRes?.progress === '100') {
      isLoading.value = false
      showTip.value = t('home.InspirationAI.searchContent')
      showKey.value = 'AIImage'
      image_ai_create.value = querySubRes.data
      await fetchHistory()
      break
    }
    await sleep(2000)
  }
}
const image_detail = ref()
const goToImageDetail = (item: any) => {
  image_detail.value = item
  isDetail.value = true
}
const goToAIImage = (item: any) => {
  if (item && item.length == 4) {
    image_ai_create.value = item
    showKey.value = 'AIImage'
  }
}
const reselect = () => {
  isDetail.value = false
}
const goToLeft = (id: any) => {
  if (image_ai_create.value && image_ai_create.value.length == 4) {
    const index = image_ai_create.value.findIndex((r: any) => r.id === id)
    const length = image_ai_create.value.length
    const AIIndex = index === 0 ? length - 1 : index - 1
    image_detail.value = image_ai_create.value[AIIndex]
  }
}
const goToRight = (id: any) => {
  if (image_ai_create.value && image_ai_create.value.length == 4) {
    const index = image_ai_create.value.findIndex((r: any) => r.id === id)
    const length = image_ai_create.value.length
    const AIIndex = index + 1 === length ? 0 : index + 1
    image_detail.value = image_ai_create.value[AIIndex]
  }
}
const goToDesign = () => {
  router.push({ path: "/products/custom_spus_design", query: { image: image_detail.value.imageUrl } })
}
</script>

<style scoped lang="less">
.ai-content {
  background: url('../assets/imgs/ai_bg.png') center/cover repeat-y;
  position: relative;
  height: 100vh;

  :deep(.header-menu) {
    background: none;
    color: #fff !important;
    position: sticky;
    top: 0;
    left: 0;

    .flex-btn {

      :deep(.user-profile-control) {
        color: #fff !important;
      }
    }

    .menuLabel {
      color: #fff !important;
    }

    .username {
      color: #fff;
    }
  }


  .search-content {
    padding: 40px 260px;
    height: 140px;
    display: flex;
    align-items: center;
    position: sticky;
    top: 101px;
    left: 0;

    .loadingBtn {
      opacity: 0.4;

      &::after {
        content: "";
        animation: dots 2s infinite steps(3, start);
      }

      @keyframes dots {
        25% {
          content: " .";
        }

        50% {
          content: " ..";
        }

        75% {
          content: " ...";
        }
      }
    }

    .ant-input {
      flex: 1;
      height: 60px;
      background: rgba(255, 255, 255, 0.1);
      color: #fff;
      border: 1px solid rgba(255, 255, 255, 0.2)
    }

    .ant-btn {
      padding: 0 20px;
      line-height: 60px;
      height: 60px;
      border: 1px solid rgba(255, 255, 255, 0.4);
      color: #fff;
      background: #111;
      margin-left: 20px;
    }

    .btn-width {
      width: 90px;
    }

    .separate-line {
      display: inline-block;
      width: 1px;
      height: 32px;
      background: #FFFFFF;
      opacity: 0.1;
      margin: 0 25px;
    }

    .ai-icon {
      width: 34px;
      height: 34px;
      cursor: pointer;
    }

    .ai-list {
      background: url('../assets/imgs/ic_create.png') center/cover no-repeat;
      margin-right: 25px;
    }

    .ai-coin {
      background: url('../assets/imgs/ic_coin.png') center/cover no-repeat;
      margin-right: 10px;
    }

    .coin-box {
      font-size: 20px;
      font-weight: bold;
      color: #FFFFFF;
    }
  }

  .ai-container {
    padding: 0 260px;
    width: 100%;
    height: calc(100vh - 280px);
    overflow: auto;

    .inspiration-image {
      display: grid;
      grid-template-columns: repeat(5, 1fr);


      .image-text {
        position: absolute;
        top: 0;
        left: 0;
        width: 264px;
        height: 264px;
        padding: 80px 60px;
        line-height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 10;
      }

      .image-preset {
        position: relative;
        // width: 18%;
        display: inline-block;
        // margin-right: 2%;
      }

      :deep(.ant-image-img) {
        width: 264px;
        height: 264px;
        margin-bottom: 20px;
      }
    }

    .inspiration-ai {
      .inspiration-icon {
        width: 26px;
        height: 23px;
        background: url('../assets/imgs/ic_inspiration.png') center/cover no-repeat;
      }

      .inspiration-title {
        height: 23px;
        line-height: 23px;
        color: #fff;
        margin-left: 10px;
      }

      .inspiration-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: calc(100vh - 310px);

        .loading-image {
          width: 300px;
          height: 300px;
        }

        .scan-image {
          width: 300px;
          height: 187px;
          position: absolute;
          top: 0;
          left: 0;
          animation: move 2s linear infinite;
        }

        @keyframes move {
          0% {
            top: -187px;
          }

          /*循环开始位置*/
          100% {
            top: 150px;
          }

          /*循环结束位置*/
        }

        .loading-title {
          margin-top: 40px;
          color: #fff;
          font-size: 14px;
          display: flex;
          align-items: baseline;
        }

        .loading-subtitle {
          min-width: 250px;

          &::after {
            content: "";
            animation: dots 2s infinite steps(3, start);
          }

          @keyframes dots {
            25% {
              content: " .";
            }

            50% {
              content: " ..";
            }

            75% {
              content: " ...";
            }
          }
        }

        .loading-progress {
          color: #6cacff;
          font-size: 24px;
          font-weight: bold;
          margin-right: 3px;
          margin-left: 15px;
        }
      }

      .inspiration-ai-create {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 800px;
        padding: 40px 0;
        margin: auto;

        :deep(.ant-image-img) {
          width: 300px;
          height: 300px;
          margin-bottom: 20px;
          margin-left: 20px;
          cursor: pointer;

          &:hover {
            border: 4px solid #FFFFFF;
          }
        }
      }

      .inspiration-ai-list {
        width: calc(100vw - 520px);
        margin-top: 40px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 30px;
        margin-bottom: 30px;

        .history-item {
          cursor: pointer;

          &:hover {
            border: 2px solid #FFFFFF;
          }

          .loading-data {
            // width: 340px;
            // height: 340px;
            padding-top: 100%;
            border: 1px solid rgba(255, 255, 255, 0.4);
            color: #fff;
            position: relative;

            .loading-icon {
              width: 20px;
              height: 20px;
              position: absolute;
              top: calc(50% - 0.33rem);
              left: calc(50% - 0.33rem);
            }
          }
        }
      }
    }
  }

  .image-content {
    padding: 0 260px;
    width: 100%;
    height: calc(100vh - 280px);
    overflow: auto;

    .image-title {
      color: #fff;
      display: flex;
      align-items: center;
      cursor: pointer;
      margin-bottom: 40px;

      .select-icon {
        width: 11px;
        height: 18px;
        background: url('../assets/ai_imgs/ic_select.png') center/cover no-repeat;
        margin-right: 10px;
      }
    }

    :deep(.ant-image-img) {
      width: 600px;
      height: 600px;
      margin: 0 30px;
    }

    .left-arrow {
      width: 31px;
      height: 11px;
      background: url('../assets/ai_imgs/ic_left_arrow.png') center/cover no-repeat;
      cursor: pointer;
    }

    .right-arrow {
      width: 31px;
      height: 11px;
      background: url('../assets/ai_imgs/ic_right_arrow.png') center/cover no-repeat;
      cursor: pointer;
    }

    .detail-content {
      flex: 1;
      color: #fff;
      margin-left: 40px;

      .detail-prompt {
        font-size: 20px;
        margin-bottom: 25px;
        word-break: break-all;
      }
    }

    .ant-btn {
      padding: 0 20px;
      line-height: 40px;
      height: 40px;
      border: 1px solid #fff;
      color: #fff;
      background: #111;
    }
  }

  :deep(.footer) {
    position: sticky;
    bottom: 0;
    left: 0;

    .footer-bottom {
      background: none;
    }
  }
}
</style>
